/* Silverstore redesign — small, dependency-free behaviours for the ss-* sections.
   Cart, wishlist, quick view and variant logic stay with Glozin's theme.js. */
(() => {
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const isRtl = () => document.documentElement.dir === "rtl" || document.body.classList.contains("rtl");

  document.addEventListener("click", (e) => {
    const el = e.target.closest("button,a");
    if (!el) return;

    // colour dots on product cards: swap the main image
    if (el.classList.contains("ss-dot")) {
      const card = el.closest(".ss-card");
      card.querySelectorAll(".ss-dot").forEach((d) => d.setAttribute("aria-pressed", String(d === el)));
      const d = el.dataset, main = card.querySelector("img.main");
      if (d.ssImg && main) {
        // main = the colour's image; hover = that colour's next image, or none (never another colour)
        main.srcset = d.ssSrcset || ""; main.src = d.ssImg;
        let alt = card.querySelector("img.alt");
        if (d.ssAlt) {
          if (!alt) { alt = document.createElement("img"); Object.assign(alt, { className: "alt", alt: "", loading: "lazy", sizes: main.sizes }); main.after(alt); }
          alt.srcset = d.ssAltSrcset || ""; alt.src = d.ssAlt;
        } else if (alt) alt.remove();
      }
      // open the chosen colour from the card link and quick view
      if (d.ssUrl) {
        card.querySelectorAll(".media > a, a.meta").forEach((a) => (a.href = d.ssUrl));
        const qv = card.querySelector("select-option[data-url]");
        if (qv) qv.url = qv.dataset.url = d.ssUrl + (d.ssUrl.includes("?") ? "&" : "?") + "section_id=product-quickview&ajax=1";   // theme.js caches this.url
      }
      return;
    }

    // clips carousel arrows
    if (el.dataset.ssScroll) {
      const sec = el.closest("section");
      const row = el.dataset.ssTarget ? sec.querySelector(`[data-ss-row="${el.dataset.ssTarget}"]`) : sec.querySelector("[data-ss-clips]");
      if (row) row.scrollBy({ left: +el.dataset.ssScroll * (isRtl() ? -1 : 1) * row.clientWidth * 0.8, behavior: reduce ? "auto" : "smooth" });
      return;
    }

    // clip play: swap the cover for the video (only one clip plays at a time)
    if (el.dataset.ssPlay !== undefined) {
      const src = el.dataset.ssPlay;
      if (!src) { el.title = el.dataset.ssMissing || ""; el.setAttribute("aria-disabled", "true"); return; }
      document.querySelectorAll(".ss-clip video").forEach((other) => other.pause());
      const frame = el.closest(".frame");
      const v = document.createElement("video");
      Object.assign(v, { src, controls: true, playsInline: true, preload: "auto" });
      if (el.dataset.ssPoster) v.poster = el.dataset.ssPoster;
      v.setAttribute("playsinline", "");
      frame.replaceChildren(v);
      v.play().catch(() => {});   // started by a click, so playback with sound is allowed
      v.focus();
      return;
    }

    // image lightbox (client message screenshots) instead of a new tab
    if (el.hasAttribute("data-ss-lightbox")) {
      const d = document.getElementById("ss-lightbox");
      if (!d || !d.showModal) return;   // no <dialog> support: follow the link
      e.preventDefault();
      const img = d.querySelector("[data-ss-lightbox-img]");
      img.src = el.getAttribute("href");
      img.alt = el.dataset.ssAlt || "";
      d.showModal();
      return;
    }

    // client messages: reveal all
    if (el.hasAttribute("data-ss-allmsgs")) {
      const list = el.closest("section").querySelector("[data-ss-msgs]");
      list && list.classList.add("show-all");
      el.closest("p").remove();
      return;
    }

    // collection "Show more": fetch the next page and append its cards (link works without JS)
    if (el.hasAttribute("data-ss-loadmore")) {
      const nav = el.closest("[data-ss-more]"), grid = nav && nav.parentElement.querySelector("[data-ss-grid]");
      if (!grid || !window.fetch) return;
      e.preventDefault();
      nav.classList.add("loading");
      fetch(el.href).then((r) => r.text()).then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const nextGrid = doc.querySelector("[data-ss-grid]"), nextNav = doc.querySelector("[data-ss-more]");
        if (nextGrid) grid.append(...nextGrid.children);
        if (nextNav) { nextNav.querySelector('a.ss-ul')?.remove(); nav.replaceWith(nextNav); } else nav.remove();
      }).catch(() => { location.href = el.href; });
      return;
    }

    // ring size guide dialog
    if (el.hasAttribute("data-ss-sizeguide")) {
      const d = document.getElementById("ss-size-guide");
      if (d && d.showModal) { e.preventDefault(); d.showModal(); }
      return;
    }
    if (el.hasAttribute("data-ss-close")) { el.closest("dialog")?.close(); return; }
  });

  // mobile filter rows scroll sideways: bring the selected chip into view
  const centerChips = () => document.querySelectorAll(".ss-filters .chips").forEach((row) => {
    const on = row.querySelector('[aria-current="page"]:not(:first-child), [aria-pressed="true"]');
    if (on && row.scrollWidth > row.clientWidth) row.scrollLeft += on.getBoundingClientRect().left - row.getBoundingClientRect().left - 16;
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", centerChips); else centerChips();

  // "You may also like": load Shopify recommendations into the section after the page renders
  document.querySelectorAll("[data-ss-recos]").forEach((box) => {
    if (!box.dataset.url) return;
    const load = () => fetch(box.dataset.url).then((r) => r.text()).then((html) => {
      const fresh = new DOMParser().parseFromString(html, "text/html").querySelector("[data-ss-recos]");
      if (fresh && fresh.querySelector(".ss-grid")) box.innerHTML = fresh.innerHTML;   // keep the collection fallback otherwise
    }).catch(() => {});
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver((es) => { if (es.some((x) => x.isIntersecting)) { io.disconnect(); load(); } }, { rootMargin: "600px" });
      io.observe(box);
    } else load();
  });


  /* ---------- client messages + clips: auto slider (one item per step, loops; pauses on hover/focus, while a clip plays, off screen or hidden tab) ---------- */
  document.querySelectorAll("[data-ss-auto]").forEach((row) => {
    const ms = +row.dataset.ssAuto || 4000;
    if (reduce || row.children.length < 2) return;
    let timer = null, hover = false, visible = true, playing = false;
    const step = () => {
      const max = row.scrollWidth - row.clientWidth; if (max < 2) return;
      const card = row.children[0], gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      const pos = Math.abs(row.scrollLeft), next = pos >= max - 2 ? 0 : Math.min(pos + card.getBoundingClientRect().width + gap, max);
      row.scrollTo({ left: isRtl() ? -next : next, behavior: "smooth" });
    };
    const run = () => { clearInterval(timer); timer = !hover && !playing && visible && !document.hidden ? setInterval(step, ms) : null; };
    row.addEventListener("mouseenter", () => { hover = true; run(); });
    row.addEventListener("mouseleave", () => { hover = false; run(); });
    row.addEventListener("focusin", () => { hover = true; run(); });
    row.addEventListener("focusout", () => { hover = false; run(); });
    document.addEventListener("visibilitychange", run);
    // the arrows restart the countdown so a click isn't followed straight away by an auto step
    row.closest("section").querySelectorAll(`[data-ss-target="${row.dataset.ssRow}"]`).forEach((b) => b.addEventListener("click", run));
    // media events don't bubble, so listen in the capture phase for the clip videos
    const onMedia = () => { playing = [...row.querySelectorAll("video")].some((v) => !v.paused && !v.ended); run(); };
    ["play", "pause", "ended"].forEach((t) => row.addEventListener(t, onMedia, true));
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; run(); }).observe(row);
  });

  /* ---------- PDP: keep the "Add to bag · price" in step with the selected variant ---------- */
  document.querySelectorAll("[id^='price-']").forEach((box) => {
    const root = box.closest(".main-product-section, .product-detail__information, section") || document;
    const btnPrice = root.querySelector("[data-ss-btnprice]");
    if (!btnPrice) return;
    const sync = () => {
      const el = box.querySelector(".price-regular .price") || box.querySelector(".price");
      const txt = el && el.textContent.trim(); if (!txt) return;
      btnPrice.textContent = txt;
    };
    new MutationObserver(sync).observe(box, { childList: true, subtree: true, characterData: true });
  });

  /* ---------- Judge.me: a product with no reviews yet opens on the store reviews tab ---------- */
  const jm = document.getElementById("judgeme_product_reviews");
  if (jm) {
    const flip = () => {
      const tabs = jm.querySelectorAll("button.jdgm-tab"); if (tabs.length < 2) return false;
      if (/\(0\)/.test(tabs[0].textContent) && !/\(0\)/.test(tabs[1].textContent) && tabs[0].getAttribute("aria-selected") === "true") tabs[1].click();
      return true;
    };
    if (!flip()) { const mo = new MutationObserver(() => { if (flip()) mo.disconnect(); }); mo.observe(jm, { childList: true, subtree: true }); setTimeout(() => mo.disconnect(), 20000); }
  }

  /* ---------- collection: filter panel on phones (sidebar on desktop is pure CSS) ---------- */
  document.querySelectorAll("[data-ss-collection]").forEach((col) => {
    const side = col.querySelector("[data-ss-filters]"), openBtn = col.querySelector("[data-ss-filters-open]"), scrim = col.querySelector(".ss-side-scrim");
    if (!side || !openBtn) return;
    const set = (on) => {
      side.classList.toggle("is-open", on); if (scrim) scrim.hidden = !on;
      openBtn.setAttribute("aria-expanded", String(on)); document.documentElement.classList.toggle("ss-filters-open", on);
      if (on) (side.querySelector(".side-close") || side).focus(); else openBtn.focus();
    };
    openBtn.addEventListener("click", () => set(true));
    col.querySelectorAll("[data-ss-filters-close]").forEach((b) => b.addEventListener("click", () => set(false)));
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && side.classList.contains("is-open")) set(false); });
    matchMedia("(min-width: 990px)").addEventListener("change", (m) => { if (m.matches && side.classList.contains("is-open")) set(false); });
  });

  /* ---------- hero slider: fade, arrows, dots, pause; auto scroll options come from the section settings ---------- */
  document.querySelectorAll("[data-ss-slider]").forEach((sl) => {
    const slides = [...sl.querySelectorAll(".slide")], dots = [...sl.querySelectorAll(".dot")];
    if (slides.length < 2) return;
    const d = sl.dataset, pauseBtn = sl.querySelector("[data-slpause]"), wait = Math.max(+d.interval || 5000, 1500);
    const autoplay = d.autoplay !== "false", hoverPause = d.pauseHover === "true";
    let i = 0, timer = null, paused = !autoplay || (d.reduce === "true" && reduce), hold = false;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => { const on = k === i; s.classList.toggle("on", on); s.toggleAttribute("inert", !on); s.setAttribute("aria-hidden", String(!on)); });
      dots.forEach((dt, k) => dt.setAttribute("aria-current", String(k === i)));
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => { stop(); if (autoplay && !paused && !hold && !document.hidden) timer = setInterval(() => go(i + 1), wait); };
    const setPaused = (p) => {
      paused = p;
      if (pauseBtn) { pauseBtn.classList.toggle("paused", p); pauseBtn.setAttribute("aria-pressed", String(p)); pauseBtn.setAttribute("aria-label", p ? pauseBtn.dataset.labelPlay : pauseBtn.dataset.labelPause); }
      start();
    };
    sl.classList.add("ready");
    sl.addEventListener("click", (e) => {
      const b = e.target.closest("button"); if (!b) return;
      if (b.dataset.sl) { go(i + (+b.dataset.sl) * (isRtl() ? -1 : 1)); start(); }
      else if (b.dataset.sldot !== undefined) { go(+b.dataset.sldot); start(); }
      else if (b.hasAttribute("data-slpause")) setPaused(!paused);
    });
    if (hoverPause) {
      sl.addEventListener("mouseenter", () => { hold = true; stop(); });
      sl.addEventListener("mouseleave", () => { hold = false; start(); });
    }
    /* keyboard users: hold while focus is inside the slider */
    sl.addEventListener("focusin", (e) => { if (e.target.matches(":focus-visible")) { hold = true; stop(); } });
    sl.addEventListener("focusout", (e) => { if (!sl.contains(e.relatedTarget)) { hold = false; start(); } });
    /* swipe on touch screens */
    let x0 = null;
    sl.addEventListener("touchstart", (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    sl.addEventListener("touchend", (e) => {
      if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1) * (isRtl() ? -1 : 1)); start(); }
    }, { passive: true });
    document.addEventListener("visibilitychange", start);
    /* theme editor: show the selected slide */
    sl.addEventListener("shopify:block:select", (e) => { const k = slides.indexOf(e.target.closest(".slide")); if (k > -1) { go(k); hold = true; stop(); } });
    sl.addEventListener("shopify:block:deselect", () => { hold = false; start(); });
    setPaused(paused);
  });


  /* ---------- VIP: block-built form → WATI API (addContact + optional welcome template), WhatsApp chat as fallback ---------- */
  document.querySelectorAll("form[data-ss-vip]").forEach((form) => {
    const ok = form.querySelector("[data-ss-vip-ok]"), btn = form.querySelector("[data-ss-vip-btn]");
    const err = form.querySelector("[data-ss-vip-err]"), done = form.parentElement.querySelector("[data-ss-vip-done]");
    const waBtn = done && done.querySelector("[data-ss-vip-wa]");
    const fields = [...form.querySelectorAll("[data-ss-vip-field]")];
    const d = form.dataset;
    if (!ok || !btn) return;
    const sync = () => btn.setAttribute("aria-disabled", String(!ok.checked));
    ok.addEventListener("change", sync); sync();
    fields.forEach((f) => f.addEventListener("input", () => { f.removeAttribute("aria-invalid"); if (err) err.hidden = true; }));

    // Local numbers (01X…) become international digits for WATI: 20 1X… (country code from Theme settings)
    const toIntl = (v) => {
      let n = v.replace(/[^\d+]/g, "");
      if (n.startsWith("+")) return n.slice(1);
      if (n.startsWith("00")) return n.slice(2);
      if (n.startsWith("0")) return (d.watiCc || "20") + n.slice(1);
      return n;
    };
    const valid = (f) => {
      const v = f.value.trim();
      if (!v) return !f.required;
      if (f.dataset.ssVipField === "phone") return /^\+?[\d\s()-]{8,}$/.test(v);
      if (f.type === "email") return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
      return true;
    };
    const waLink = (vals) => {
      const lines = vals.filter((x) => x.value).map((x) => x.label + ": " + x.value);
      return (d.wa || "") + "?text=" + encodeURIComponent([d.msg, ...lines].filter(Boolean).join("\n"));
    };
    const finish = (fallbackHref, vals) => {
      form.hidden = true;
      if (!done) return;
      // greet by first name when the form had a name field
      const hi = done.querySelector("[data-ss-vip-hi]"), name = ((vals || []).find((x) => x.type === "name") || {}).value;
      if (hi && name) { hi.textContent = hi.dataset.tpl.replace("[name]", name.split(/\s+/)[0]); hi.hidden = false; }
      done.hidden = false;
      if (waBtn) { waBtn.hidden = !fallbackHref; if (fallbackHref) waBtn.href = fallbackHref; }
      done.focus();
    };
    const wati = async (vals) => {
      const base = d.watiEndpoint.replace(/\/+$/, "");
      const head = { "Content-Type": "application/json", Authorization: "Bearer " + d.watiToken };
      const phone = vals.find((x) => x.type === "phone");
      if (!phone || !phone.value) throw new Error("no phone");
      const num = toIntl(phone.value);
      const name = (vals.find((x) => x.type === "name") || {}).value || "";
      const params = vals.filter((x) => x.type !== "phone" && x.type !== "name" && x.value).map((x) => ({ name: x.key, value: x.value }));
      if (d.watiSource) params.push({ name: "source", value: d.watiSource });
      const r = await fetch(`${base}/api/v1/addContact/${num}`, { method: "POST", headers: head, body: JSON.stringify({ name, customParams: params }) });
      if (!r.ok) throw new Error("addContact " + r.status);
      if (d.watiTemplate) {
        const t = await fetch(`${base}/api/v1/sendTemplateMessage?whatsappNumber=${num}`, {
          method: "POST", headers: head,
          body: JSON.stringify({ template_name: d.watiTemplate, broadcast_name: d.watiBroadcast || "shopify_vip", parameters: [{ name: "name", value: name || "" }] }),
        });
        if (!t.ok) console.warn("[VIP] WATI template not sent:", t.status);
      }
    };

    // relay (Cloudflare Worker): saves to WATI + creates the Shopify customer tagged "vip"; no tokens in the page
    const relay = async (vals) => {
      const hp = form.querySelector("[data-ss-vip-hp]");
      const r = await fetch(d.vipRelay, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: (vals.find((x) => x.type === "name") || {}).value || "",
          phone: (vals.find((x) => x.type === "phone") || {}).value || "",
          consent: ok.checked,
          fields: vals.filter((x) => x.type !== "phone" && x.type !== "name" && x.value).map((x) => ({ name: x.key, value: x.value })),
          website: hp ? hp.value : "",
        }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || !j.ok) throw new Error("relay " + r.status);
      if (j.wati !== "saved" || !/created|tagged/.test(j.shopify || "")) console.warn("[VIP] partial save:", j);
    };

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const bad = fields.filter((f) => !valid(f));
      fields.forEach((f) => f.toggleAttribute("aria-invalid", bad.includes(f)));
      if (bad.length || !ok.checked) { if (err) err.hidden = false; (bad[0] || ok).focus(); return; }
      const vals = fields.map((f) => ({ type: f.dataset.ssVipField, key: f.dataset.key, label: f.dataset.label, value: f.value.trim() }));
      if (!d.vipRelay && !d.watiEndpoint) { finish(waLink(vals), vals); return; }
      btn.setAttribute("aria-busy", "true"); btn.disabled = true;
      try { await (d.vipRelay ? relay(vals) : wati(vals)); finish(null, vals); }
      catch (x) { console.warn("[VIP] WATI unavailable, falling back to WhatsApp:", x); finish(waLink(vals), vals); }
      finally { btn.removeAttribute("aria-busy"); btn.disabled = false; }
    });
  });


  /* ---------- SS header: mega panels (hover on desktop, click/keyboard everywhere), phone drawer, drawer tabs ---------- */
  document.querySelectorAll("[data-ss-header]").forEach((hdr) => {
    const btns = [...hdr.querySelectorAll("[data-ss-mega]")];
    const panel = (id) => hdr.querySelector(`[data-ss-mega-panel="${id}"]`);
    const close = () => btns.forEach((b) => { b.setAttribute("aria-expanded", "false"); const p = panel(b.dataset.ssMega); if (p) p.hidden = true; });
    const open = (b) => { close(); b.setAttribute("aria-expanded", "true"); const p = panel(b.dataset.ssMega); if (p) p.hidden = false; };
    const canHover = matchMedia("(hover:hover) and (pointer:fine)").matches;
    btns.forEach((b) => {
      b.addEventListener("click", () => (b.getAttribute("aria-expanded") === "true" ? close() : open(b)));
      if (canHover) b.addEventListener("mouseenter", () => open(b));
    });
    hdr.querySelectorAll(".ss-nav-item:not([data-ss-mega])").forEach((a) => canHover && a.addEventListener("mouseenter", close));
    if (canHover) hdr.addEventListener("mouseleave", close);
    hdr.addEventListener("focusout", (e) => { if (!hdr.contains(e.relatedTarget)) close(); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && btns.some((b) => b.getAttribute("aria-expanded") === "true")) { const b = btns.find((x) => x.getAttribute("aria-expanded") === "true"); close(); b && b.focus(); } });
  });
  document.addEventListener("click", (e) => {
    const o = e.target.closest("[data-ss-open]");
    if (o) { const d = document.getElementById(o.dataset.ssOpen); if (d && d.showModal) { e.preventDefault(); d.showModal(); } return; }
    const tab = e.target.closest("[data-ss-mtab]");
    if (tab) {
      const dlg = tab.closest("dialog");
      dlg.querySelectorAll("[data-ss-mtab]").forEach((b) => b.setAttribute("aria-pressed", String(b === tab)));
      dlg.querySelectorAll("[data-ss-mtab-panel]").forEach((p) => (p.hidden = p.dataset.ssMtabPanel !== tab.dataset.ssMtab));
    }
  });

  // click on the dialog backdrop closes it
  document.addEventListener("click", (e) => {
    if (e.target.matches?.("dialog.ss-dialog, dialog.ss-lightbox, dialog.ss-drawer")) e.target.close();
  });

  // newsletter: consent + email check before the Shopify customer form posts
  document.addEventListener("submit", (e) => {
    const f = e.target;
    if (!f.matches("[data-ss-news]")) return;
    const status = f.querySelector("[data-ss-status]");
    const email = f.querySelector('input[type="email"]');
    const ok = f.querySelector("[data-ss-consent]");
    if (!/^\S+@\S+\.\S+$/.test(email.value.trim())) {
      e.preventDefault(); status.className = "ss-status err"; status.textContent = status.dataset.bad; email.focus(); return;
    }
    if (ok && !ok.checked) {
      e.preventDefault(); status.className = "ss-status err"; status.textContent = status.dataset.need; ok.focus();
    }
  });
})();
